import Vue from 'vue';
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    iconSort: 1
  },
  actions: {
  },
  mutations: {
    setLoading (state, value) {
      state.loading = value
    },
    setIconSort (state, value) {
      state.iconSort = value
    }
  }
})
